<template>
	<section class="mt-5" id="selected-video">
		<div class="container-fluid px-3 px-lg-5 px-xl-5">
      <div class="row m-0">
        <div class="col-12 p-0 selected-video-container">
          <VideoLibraryItem
            :videoId="videoItem.videoId"
            :videoTitle="videoItem.videoTitle"
            :videoTextDescription="videoItem.videoTextDescription"
            :videoThumbnail="videoItem.videoThumbnail?.includes('https://projectspectrumlearning.io/') ? videoItem.videoThumbnail : require(`@assetsImages/${videoItem.videoThumbnail}.png`)"
            :videoSrc="videoItem.videoSrc"
            :isMP4Video="videoItem.isMP4Video"
            :videoClasses="'flex-lg-row flex-xl-row justify-content-center'"
            :columnClass="'col-12 col-lg-6 col-xl-6'"
            :videoContainerClasses="'video-container-padding'"
            :isVideoPlayerPlayer="isVideoPlayerPlayer"
            :showShareButtonFromLeft="isDesktop"
            :videoShare="videoItem.videoShare"
          />
        </div>
      </div>
		</div>
	</section>
</template>

<script>
  import VideoLibraryItem from "./video-library-item.vue";

  export default {
    components: {
      VideoLibraryItem,
    },
    props: {
      videoItem: Object,
      isVideoPlayerPlayer: {
        type: Function,
        default: () => {},
      }
    },
    computed: {
      isDesktop() {
        return !(this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm);
      } 
    },
    watch: {
      videoItem(newVideoItem, oldVideoItem) {
        if(newVideoItem) {
          const { videoId: oldVideoId } = oldVideoItem;
          const { videoSrc: newVideoSrc } = newVideoItem;
          const currentVideoEl = document.getElementById(oldVideoId);
          currentVideoEl.pause();
          currentVideoEl.currentTime = 0;
          const currentVideoElSource = currentVideoEl.querySelectorAll("source")[0];
          currentVideoElSource.src = newVideoSrc;
          currentVideoEl.load();
        }
      }
    }
  }
</script>

<style scoped>
  .selected-video-container {
    min-width: 340px;
  }
</style>